import CACClickChartWrap from "./CACClickChart/CACClickChartWrap"
import CACClickSortWrap from "./CACClickSortWrap"


const CACClick = () => {
  return (
    <>
    <CACClickSortWrap/>
    <CACClickChartWrap/>
    </>
  )
}

export default CACClick